import type { SendInputFailureKind } from '@/model/Agent.model';

/** The title wherever a run stopped on input it could not read: the tree's step and both SEND modals. */
export const SEND_UNREADABLE_TITLE = 'SEND files could not be read';

/**
 * What a user does about each way an upload can fail to be read. Typed by the generated kind union,
 * so a kind the server adds without copy here is a compile error rather than a failure with no
 * advice. The server's own message says what went wrong; this says what to do about it.
 */
export const INPUT_FAILURE_TEXT: Record<SendInputFailureKind, string> = {
  blank_header: 'Give every column in the header row a name, then export the file again.',
  broken_quoting:
    'A quoted value is never closed. Export the file again from the source system rather than editing it by hand.',
  bundle_too_large: 'Upload fewer or smaller files in this bundle.',
  duplicate_header: 'Each column name must appear once. Remove or rename the repeated column, then export again.',
  field_too_large: 'One value is far longer than SEND allows. Check the file was not joined or damaged on export.',
  file_too_large: 'The file is over the size limit. Check it holds a single dataset, or split it.',
  inconsistent_field_count:
    'A row has a different number of values from the header, usually from a stray comma or line break. Export the file again.',
  invalid_utf8: 'Export the file again as UTF-8 text.',
  no_header: 'The first row must name the columns. Export the file with its header row.',
  record_too_large:
    'One row is far longer than SEND allows. Check for a missing line break, or a value that ran on into the rest of the file.',
  too_many_columns:
    'The file has far more columns than any SEND dataset. Check it is a single dataset exported as CSV.',
  too_many_rows_for_domain:
    'The file has more rows than this dataset should hold. Check it is not duplicated or holding more than one study.',
  too_many_rows_in_bundle:
    'The bundle holds more rows than one study should. Upload fewer files, or check for duplicates.',
  too_many_rows_in_file:
    'The file holds more rows than one dataset should. Check it is not duplicated or holding several datasets.',
};
